import { css, keyframes } from '@emotion/react';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('LoadingIndicator', [
  'loading',
  'mainCircle',
  'invert',
]);

const spinAnimation = keyframes`
  0% {
    stroke-dashoffset: 600;
    transform: rotate(0deg);
  }

  100% {
    stroke-dashoffset: 60;
    transform: rotate(720deg);
  }
`;

const pulseAnimation = keyframes`
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
`;

const styles = () => css`
  display: inline-flex;

  .${classes.loading} {
    fill: none;
    stroke-width: 0.75rem;
    width: 1.5rem;
    height: 1.5rem;
    transition: opacity 0.2s ease-in-out;
    stroke-dasharray: 300;
    animation: ${spinAnimation} 2.5s linear infinite;
  }

  .${classes.mainCircle} {
    cx: 50%;
    cy: 50%;
    r: 40px;
    stroke: var(
      --loading-indicator-stroke,
      var(--cds-color-interactive-primary)
    );
  }

  @media (prefers-reduced-motion: reduce) {
    .${classes.loading} {
      animation: ${pulseAnimation} 1.5s ease-in-out infinite;
      transition: none;
    }
  }

  &.${classes.invert} {
    circle {
      stroke: var(--cds-color-neutral-primary-invert);
    }
  }
`;

export default styles;
